var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-button',{attrs:{"type":"is-primary","size":"is-small","icon-left":"plus"},on:{"click":_vm.openModal}},[_vm._v("Crear Cama")])}
var staticRenderFns = []

export { render, staticRenderFns }